<!--
 * @Date: 2022-03-07 14:32:27
 * @LastEditTime: 2022-04-19 11:35:28
 * @Description: 补充推荐
-->
<template>
  <div class="recommendgoodat-content">
    <div v-if="tip" class="tips-content" v-html="tip" />
    <div class="list-container">
      <cube-checkbox
        v-model="isAll"
        class="all-checkout"
        position="right"
        @input="onCheckInput"
        ><div class="option-item strong">
          选择系统推荐擅长
          <span class="all-class">全选</span>
          <span :class="isAll ? 'isCheked' : ''" /></div
      ></cube-checkbox>
      <cube-checkbox-group v-model="checkList">
        <cube-checkbox
          v-for="(item, index) in good_at_list"
          :key="index"
          position="right"
          :option="item"
          ><div class="option-item">
            {{ item.label }}
            <span
              :class="checkList.includes(item.value) ? 'isCheked' : ''"
            /></div
        ></cube-checkbox>
      </cube-checkbox-group>
      <cube-checkbox
        v-model="not_recommend"
        class="all-checkout not-recommend-checkbox"
        position="right"
        ><div class="option-item">
          <div class="not-recommend">
            <span>不再推荐</span>
            <span class="desc"
              >勾选并提交后 将不再为您推荐可补充填写的擅长</span
            >
          </div>
          <span :class="not_recommend ? 'isCheked' : ''" /></div
      ></cube-checkbox>
    </div>
    <div class="bottom-btn-content">
      <div
        :class="{
          bottomBtn: true,
          disable: !checkList.length && !not_recommend,
        }"
        @click="submit"
      >
        提交
      </div>
    </div>
    <div v-if="toastShow" class="toast">
      {{ message || '擅长最多可选30' }}
    </div>
  </div>
</template>

<script>
import {
  specialtyGoodAtGetRecommendGoodAt,
  specialtyGoodAtSubmitRecommendGoodAt,
} from '@/services';
import { getQueryStr, doPoint } from '@/utils/index';
import NativeBridge from '@cy/native-bridge';
import * as cyDetect from '@cy/detect';

const webAlertParmas = {
  title: '',
  content: '您有尚未提交的信息，确认离开？',
  // 点击cancle  是留在当前页；
  // 点击confirm 是返回上一页
  cancel: '取消',
  confirm: '确认',
  close: true, // true 表示无论h5往前push多少个页面，点击confirm时都会关掉webview，回到上一个原生页面，fasle 表示该怎么样就怎么样，如果有h5历史的话就往后退一步，没有就关掉webview了
};
export default {
  name: 'RecommendGoodat',
  data() {
    return {
      tip: '',
      // 被选择的选项
      checkList: [],
      // 所有选项
      good_at_list: [],
      isAll: false, // 是否全选
      not_recommend: false, // 是否不在推荐
      toastShow: false, // 是否展示toast
      message: '', // toast消息
    };
  },
  watch: {
    // 监听checkList的变化，随时准备修改全选的状态
    checkList() {
      if (NativeBridge && NativeBridge.web_alert) {
        NativeBridge.web_alert('1.0', JSON.stringify(webAlertParmas));
      }
      this.isAll =
        this.checkList.length === this.good_at_list.length &&
        this.checkList.length > 0;
    },
    not_recommend() {
      if (NativeBridge && NativeBridge.web_alert) {
        NativeBridge.web_alert('1.0', JSON.stringify(webAlertParmas));
      }
    },
  },
  created() {
    doPoint('PageView', {
      app: 1,
      page_readable_name: '推荐擅长',
    });
    const that = this;
    // 获取页面信息
    specialtyGoodAtGetRecommendGoodAt({
      version: getQueryStr('version', window.location.href),
    })
      .then(res => {
        const {
          error_code,
          good_at_list = [],
          tip,
          doctor_writed_num,
          error_msg,
        } = res;
        if (error_code === 0) {
          that.good_at_list = good_at_list
            ? good_at_list.map(item => {
                return {
                  label: item,
                  value: item,
                };
              })
            : [];
          that.tip = tip;
          // 之前已选的数量
          that.doctor_writed_num = doctor_writed_num || 0;
        } else {
          that.message = error_msg;
          that.showToast();
        }
      })
      .catch(e => {
        const { response = {} } = e;
        const { data = {} } = response;
        that.message = data.error_msg;
        that.showToast();
        console.log(e);
      });
  },
  methods: {
    // 10.1.8全部的选择框发生改变的事件
    onCheckInput(value) {
      this.isAll = value;
      this.checkList = this.good_at_list
        .filter(i => i && value)
        .map(e => e.value);
    },
    // 提交事件
    submit() {
      if (this.checkList.length <= 0 && !this.not_recommend) return;
      if (this.doctor_writed_num + this.checkList.length > 30) {
        this.showToast();
      } else {
        this.submitData();
      }
    },
    // 提交信息发送请求
    submitData() {
      const param = {
        good_at_list: JSON.stringify(this.checkList),
        not_recommend: this.not_recommend,
        version: getQueryStr('version', window.location.href),
      };
      doPoint('AppClick', {
        app: 1,
        click_position: '提交',
        page_readable_name: '擅长推荐',
        click_position_value: this.checkList.join(','),
        is_recommend: this.not_recommend ? 1 : 0,
      });
      const that = this;
      specialtyGoodAtSubmitRecommendGoodAt(param)
        .then(res => {
          const { error_code, error_msg } = res;
          if (error_code === 0) {
            if (NativeBridge && NativeBridge.closeWebView) {
              NativeBridge.closeWebView();
            }
            if (
              cyDetect.isFromCYClinic() &&
              cyDetect.isGreaterAppVersion('5.8.2', true) &&
              that.$route.query.from_page !== 'clinic_specialty_good_at'
            ) {
              window.location.href = 'chunyu://launch/webapp/good_at_disease/';
            }
          } else {
            this.message = error_msg;
            this.showToast();
          }
        })
        .catch(e => {
          const { response = {} } = e;
          const { data = {} } = response;
          that.message = data.error_msg;
          that.showToast();
          console.log(e);
        });
    },
    // toastShow toast展示函数
    showToast() {
      this.toastShow = true;
      const that = this;
      setTimeout(() => {
        that.toastShow = false;
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.recommendgoodat-content {
  background-color: #f7f7f7;
}
.tips-content {
  padding: rem(10) rem(15);
  color: #999;
  font-size: rem(13);
  /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
  font-family: PingFangSC-Regular;
  line-height: rem(17);
  text-align: left;
}
.all-checkout {
  background: #fff;
}
.option-item {
  color: #323232;
  font-size: rem(15);
  /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
  font-family: PingFangSC-Regular;
}
.option-item.strong {
  font-weight: 700;
}
.option-item > span {
  position: absolute;
  top: 25%;
  right: 0;
  display: block;
  width: rem(20);
  height: rem(20);
  border: 0.5px solid #d8d8d8;
  border-radius: 100%;
}
.option-item > .isCheked {
  background-image: url('https://staff.chunyu.mobi/@/media/images/2022/05/30/4f98/b89b297f2834_w60_h60_.png');
  background-repeat: no-repeat;
  background-size: 100%;
}
::v-deep .cube-checkbox-wrap:not(:last-of-type) {
  border-bottom: 0.5px solid #e7e7e7;
}

.option-item.strong > .all-class {
  position: absolute;
  top: 25%;
  right: rem(10);
  display: block;
  width: rem(50);
  height: rem(20);
  // border: 0.5px solid #d8d8d8;
  // border-radius: 100%;
  // content: '';
  font-weight: 400;
  border: none;
}
.not-recommend {
  display: flex;
  flex-direction: column;
}
.not-recommend .desc {
  color: #999;
  font-size: rem(13);
  /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
  font-family: PingFangSC-Regular;
}
.not-recommend-checkbox {
  margin-top: rem(10);
}
.bottom-btn-content {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  padding: rem(8) rem(15) rem(16);
  background: #fff;
  .bottomBtn {
    padding: rem(13) 0;
    color: #fff;
    font-size: rem(16);
    /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
    font-family: PingFangSC-Medium;
    text-align: center;
    background: #1c91e0;
    border-radius: 2px;
  }
  .bottomBtn.disable {
    background: #1c91e0;
    opacity: 0.5;
  }
}
.toast {
  position: fixed;
  right: 0;
  bottom: rem(70);
  left: 0;
  width: rem(200);
  margin: auto;
  padding: rem(15) 0;
  color: #fff;
  font-size: rem(15);
  /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
  font-family: PingFangSC-Regular;
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
}
.list-container {
  padding-bottom: rem(60);
}
</style>
